import { render, staticRenderFns } from "./FormRL10.vue?vue&type=template&id=11cf0918"
import script from "./FormRL10.vue?vue&type=script&lang=js"
export * from "./FormRL10.vue?vue&type=script&lang=js"
import style0 from "./FormRL10.vue?vue&type=style&index=0&id=11cf0918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports